var _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 12,
    fill: "#FBE1E8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.0001,
    cy: 40,
    r: 28,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2501 24C57.2501 23.5858 57.5859 23.25 58.0001 23.25L65.0001 23.25C65.4143 23.25 65.7501 23.5858 65.7501 24C65.7501 24.4142 65.4143 24.75 65.0001 24.75L58.0001 24.75C57.5859 24.75 57.2501 24.4142 57.2501 24Z",
    fill: "#F7BA97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75012 49C8.75012 48.5858 9.08591 48.25 9.50012 48.25H16.5001C16.9143 48.25 17.2501 48.5858 17.2501 49C17.2501 49.4142 16.9143 49.75 16.5001 49.75H9.50012C9.08591 49.75 8.75012 49.4142 8.75012 49Z",
    fill: "#F7BA97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2501 27.5C60.2501 27.0858 60.5859 26.75 61.0001 26.75L64.0001 26.75C64.4143 26.75 64.7501 27.0858 64.7501 27.5C64.7501 27.9142 64.4143 28.25 64.0001 28.25L61.0001 28.25C60.5859 28.25 60.2501 27.9142 60.2501 27.5Z",
    fill: "#F7BA97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7501 52.5C11.7501 52.0858 12.0859 51.75 12.5001 51.75H15.5001C15.9143 51.75 16.2501 52.0858 16.2501 52.5C16.2501 52.9142 15.9143 53.25 15.5001 53.25H12.5001C12.0859 53.25 11.7501 52.9142 11.7501 52.5Z",
    fill: "#F7BA97"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7501 24C67.7501 23.5858 68.0859 23.25 68.5001 23.25H70.5001C70.9143 23.25 71.2501 23.5858 71.2501 24C71.2501 24.4142 70.9143 24.75 70.5001 24.75H68.5001C68.0859 24.75 67.7501 24.4142 67.7501 24Z",
    fill: "#F7BA97"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.553 37.5068C44.8329 37.2015 44.8123 36.727 44.5069 36.4471C44.2016 36.1672 43.7271 36.1879 43.4473 36.4932L38.4766 41.9158L36.5305 39.9697C36.2376 39.6768 35.7627 39.6768 35.4698 39.9697C35.1769 40.2626 35.1769 40.7374 35.4698 41.0303L37.9698 43.5303C38.1144 43.675 38.3119 43.7543 38.5164 43.7498C38.7209 43.7454 38.9148 43.6576 39.053 43.5068L44.553 37.5068Z",
    fill: "#E9688A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0001 27.25C32.9585 27.25 27.2501 32.9584 27.2501 40C27.2501 47.0416 32.9585 52.75 40.0001 52.75C47.0418 52.75 52.7501 47.0416 52.7501 40C52.7501 32.9584 47.0418 27.25 40.0001 27.25ZM28.7501 40C28.7501 33.7868 33.7869 28.75 40.0001 28.75C46.2134 28.75 51.2501 33.7868 51.2501 40C51.2501 46.2132 46.2134 51.25 40.0001 51.25C33.7869 51.25 28.7501 46.2132 28.7501 40Z",
    fill: "#E9688A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.211d11fb99633535ef3440b5eb5295af.svg";
export { ForwardRef as ReactComponent };